import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import "./DashboardStyle.css";
import Sidebar from "./Sidebar";

const Dashboard = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Get page title based on current route
  const getPageTitle = () => {
    const path = location.pathname;
    if (path === "/dashboard") return "Dashboard";
    if (path.includes("/file-converter")) return "Convert Files";
    if (path.includes("/files")) return "My Files";
    if (path.includes("/usage")) return "Usage Analytics";
    if (path.includes("/billing")) return "Billing & Plans";
    if (path.includes("/admin/users")) return "User Management";
    return "Dashboard";
  };

  // Get icon based on current route
  const getPageIcon = () => {
    const path = location.pathname;
    if (path === "/dashboard") return "fa-tachometer";
    if (path.includes("/file-converter")) return "fa-cloud-upload";
    if (path.includes("/files")) return "fa-folder-open-o";
    if (path.includes("/usage")) return "fa-line-chart";
    if (path.includes("/billing")) return "fa-credit-card";
    if (path.includes("/admin/users")) return "fa-users";
    return "fa-tachometer";
  };

  return (
    <div className="dash-layout">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <main className="dash-main">
        {/* Top Bar */}
        <header className="dash-topbar">
          <div className="dash-topbar-left">
            <button className="dash-menu-toggle" onClick={toggleSidebar}>
              <i className="fa fa-bars"></i>
            </button>
            <h1 className="dash-page-title">
              <i className={`fa ${getPageIcon()} me-2`}></i>
              {getPageTitle()}
            </h1>
          </div>
          <div className="dash-topbar-right">
            {user && (
              <div className="dash-topbar-user">
                <span className="dash-topbar-username">{user.email}</span>
                <div className="dash-topbar-avatar">
                  <i className="fa fa-user-circle"></i>
                </div>
              </div>
            )}
          </div>
        </header>

        {/* Dashboard Content - Outlet renders nested routes */}
        <div className="dash-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
